
import React, { useMemo, useRef, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import MaterialReactTable from 'material-react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faPencil, faQuestionCircle, faSave } from '@fortawesome/free-solid-svg-icons';
import ModalUpdateTemplateTypeColumn from '../../../components/ModalUpdateTemplateTypeColumn';
import useUtils from '../../../../utiles/useUtiles';
import Footer from '../../../components/Footer';

const TemplateTypeDetails: React.FC = () => {

    const urlParams = useParams();
    const [searchParams, setSearchParams] = useState<any>( { searchText: '' } );
    const [templateTypeDetails, setTemplateTypeDetails] = useState<any>( {
        csv_type: null,
        columns: { count: 0, rows: [] }
    } );
    const [loading, setLoading] = useState<boolean>( false );
    const [pagination, setPagination] = useState<any>( {
        pageIndex: 0,
        pageSize: 10
    } );
    const [selectedColumn, setSelectedColumn] = useState<any | null>(null);
    const [showUpdateModal, setShowUpdateModal] = useState<boolean>(false);
    const { axiosRequest, baseUrl, toastInstance, loadingScreen } = useUtils()
    const axios = axiosRequest();
    const toast = toastInstance();

    useEffect( () => {
        if ( urlParams && urlParams['id'] ) {
            fetchTemplateTypeColumns();
        }
    }, [pagination.pageIndex, pagination.pageSize, urlParams] );

   
    const columns = useMemo(
        () => [
          {
            accessorKey: 'name',
            header: 'Column Name',
            minSize: 50,
            maxSize: 120,
            Cell: ( { cell }: any ) => <span>{cell.getValue()}</span>,
          },
          {
            accessorKey: 'columnType',
            header: 'Column Type',
            minSize: 50,
            maxSize: 120,
            Cell: ( { cell } ) => <span>{cell.getValue() == 1 ? 'Stored' : 'Derived'}</span>,
          },
          {
            accessorKey: 'status',
            header: 'Status',
            minSize: 50,
            maxSize: 120,
            Cell: ( { cell } ) => <span>{cell.getValue() == 1 ? 'Active' : 'Inactive'}</span>,
          },
          {
            accessorKey: 'actions',
            header: 'Action',
            minSize: 5,
            maxSize: 10,
            Cell: ( { cell } ) => <div>
                <FontAwesomeIcon
                  title='Edit'
                  icon={faEdit}
                  className="isPointer ml-2 cursor-pointer"
                  onClick={() => updateColumn( cell.row.original )}
                />
            </div>,
          }
        ],
        [],
    );

    const updateColumn = ( columnDetails: any) => {
        setSelectedColumn(columnDetails)
        setShowUpdateModal(true)
    }

    const closeUpdateModal = () => {
        setShowUpdateModal(false);
        fetchTemplateTypeColumns();
    }

    const onSearchChange = ( field: string, value: string ) => {
        setSearchParams( {
          ...searchParams,
          [field]: value
        } );
    };

    const fetchTemplateTypeColumns = async () => {
        if ( urlParams && urlParams['id'] ) {
            setLoading( true );
            const searchString = Object.keys( searchParams )
            .filter( key => searchParams[key] )
            .map( key => `${key}=${searchParams[key]}` ).join( '&' );

            const request = await axios.get( `${baseUrl()}/template_types/${urlParams['id']}?page=${pagination.pageIndex}&pageSize=${pagination.pageSize}&${searchString}` );
            const { error, message, result } = request.data;
            setLoading( false );
            if ( error ) {
                toast.error( message );
            } else {
                if ( result ) {
                    setTemplateTypeDetails( result );
                }
            }
        } else {

        }
    };

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="main-container">
                          <div className="main-container-inner">
                            {/* <div className="logo mb-3"><img src="logo-min.png" /></div> */}
                            <div className="main-card revrex-data-table-card">
                                <div className='d-flex justify-content-between align-items-center mb-3'>
                                    <h1 className='page-title-sm'>Template Type, <strong>{templateTypeDetails?.csv_type?.name}</strong> Column List</h1>
                                    
                                </div>
                                <div className='mb-4 d-flex gap-10'>
                                    <div className='flex-grow-1'>
                                        <input type={"text"} name="searchText" placeholder="Column name" className="form-control" autoComplete='new-password' onChange={( e ) => onSearchChange( 'searchText', e.target.value )} />
                                    </div>
                                    <div className=''>
                                        <button type="button" className="btn btn-md btn-custom-secondary" onClick={fetchTemplateTypeColumns}>Search</button>
                                    </div>
                                </div>
                                <MaterialReactTable 
                                    columns={columns} 
                                    data={templateTypeDetails?.columns.rows} 
                                    rowCount={templateTypeDetails?.columns.count} 
                                    enableColumnOrdering={false} 
                                    enableRowSelection={false} 
                                    enableSelectAll={false}
                                    enableColumnActions={false}
                                    manualPagination
                                    onPaginationChange={setPagination}
                                    state={{ pagination }}
                                    enableSorting={false}
                                    enableGlobalFilter={false}
                                    enableFullScreenToggle={false}
                                    enableDensityToggle={false}
                                    enableHiding={false}
                                    enableColumnFilters
                                    enableFilters={false}
                                />
                            </div>
                          </div>
                          <Footer />
                        </div>
                    </div>
                </div>
                {
                    showUpdateModal && 
                    <ModalUpdateTemplateTypeColumn 
                     handleClose={closeUpdateModal}
                     columnDetails={selectedColumn}
                     show={showUpdateModal}
                    /> || <></>
                }
            </div>
            {loadingScreen( loading )}
        </>
    );
}

export default TemplateTypeDetails